<template>
  <div v-if="esGranted" class="col-12 mb-3" :class="esVistaGrafica ? 'col-sm-6 col-lg-3' : 'mt-4 position-sticky left-0 vw-100'" slot="footer">
    <div class="card h-100" :class="esVistaGrafica ? 'hover-light' : 'border-0'">
      <div class="card-body d-flex align-items-center justify-content-center flex-column py-5">
        <label class="mb-0" :class="{ 'd-flex': !esVistaGrafica }">
          <i class="fas fa-circle-plus fa-10x text-muted mb-5" title="Incloure projecte en seguiment" :class="{ 'd-none': !esVistaGrafica }" v-tooltip></i>
          <div class="input-group">
            <div class="input-group-prepend">
              <div class="input-group-text"><i class="fas fa-archive" title="Projecte" v-tooltip></i></div>
            </div>
            <select class="custom-select" v-model="proyectoIncluible" :disabled="loading">
              <option value="" hidden>Projecte</option>
              <option v-for="(proyecto, index) in posibles" :key="index" :value="proyecto.id">{{ proyecto.cliente }} → {{ proyecto.titol }}</option>
            </select>
          </div>
        </label>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'KPIProyectoNuevo',
  props: {
    esVistaGrafica: Boolean,
    esGranted: Boolean,
    posibles: Array,
    trabajador: Number,
  },
  data() {
    return {
      loading: false,
      proyectoIncluible: "",
    };
  },
  watch: {
    proyectoIncluible(value) {
      if (!value) return;

      this.loading = true;

      this.$http
        .post("api/kpis", { id_projecte: value, es_visible: true, id_treballador: this.trabajador })
        .then((response) => {
          if (![200, 201, 409].includes(response.status)) return;

          this.proyectoIncluible = "";

          this.$emit("incluirProyecto", value);
        })
        .finally(() => (this.loading = false));
    },
  },
}
</script>
